import React from 'react';
import PropTypes from 'prop-types';
import StandardModal from './StandardModal';
import Icon from './Icon';
import StandardButton from './StandardButton';
import { primitives } from '@lexody/design-tokens';

class AlertModal extends React.Component {
  render() {
    const {
      alert,
      onClose,
      onClick,
      bannerText,
      headerText,
      subHeaderText,
      mainText,
      buttonText,
    } = this.props;

    const isError = alert === true;
    const modalClass = isError
      ? 'standardModal--alert standardModal--alertError'
      : 'standardModal--alert standardModal--alertSuccess';

    const iconName = isError ? 'exclamation-circle' : 'check-circle';
    const iconColor = isError ? primitives.pink['600'] : primitives.green['600'];
    const showBadge = Boolean(bannerText && headerText);
    const titleText = headerText || bannerText;

    return (
      <StandardModal
        onClose={onClose}
        title={titleText}
        modalClass={modalClass}
        showCloseButton
      >
        <div className="alert-modal">
          <div
            className={`alert-modal__iconCircle${isError ? ' alert-modal__iconCircle--error' : ' alert-modal__iconCircle--success'}`}
            aria-hidden="true"
          >
            <Icon name={iconName} size={28} color={iconColor} />
          </div>

          {showBadge && (
            <p className={`alert-modal__badge${isError ? ' alert-modal__badge--error' : ' alert-modal__badge--success'}`}>
              {bannerText}
            </p>
          )}

          {titleText && (
            <h2 className="alert-modal__title">{titleText}</h2>
          )}

          {subHeaderText && (
            <p className="alert-modal__subtitle">{subHeaderText}</p>
          )}

          {mainText && (
            <p className="alert-modal__body">{mainText}</p>
          )}

          <div className="alert-modal__actions">
            <StandardButton
              text={buttonText}
              size="large"
              primary={!isError}
              alert={isError}
              fullWidth
              onClick={onClick}
            />
          </div>
        </div>
      </StandardModal>
    );
  }
}

AlertModal.propTypes = {
  alert: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  bannerText: PropTypes.string,
  headerText: PropTypes.string,
  subHeaderText: PropTypes.string,
  mainText: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
};

export default AlertModal;
